import { render, staticRenderFns } from "./IssueContainer.vue?vue&type=template&id=9e3b42a2"
import script from "./IssueContainer.vue?vue&type=script&lang=js"
export * from "./IssueContainer.vue?vue&type=script&lang=js"
import style0 from "./IssueContainer.vue?vue&type=style&index=0&id=9e3b42a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports